import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useExplorerMessagingLimit } from "../../hooks/useExplorerMessagingLimit";
import { getExplorerMessagingLimitCounterMessage } from "../../utils/explorerMessagingLimitCopy";

type Props = {
  className?: string;
  variant?: "info" | "warning";
};

/** Explorer weekly messaging budget — visible before and at the weekly limit. */
export function ExplorerMessagingLimitCounter({
  className = "mb-0",
  variant = "info",
}: Props) {
  const { t, i18n } = useTranslation();
  const { isExplorer, used, limit, weekResetsUtc, canSendMessage } =
    useExplorerMessagingLimit();

  if (!isExplorer) return null;

  const locale = i18n.resolvedLanguage ?? i18n.language;
  const message = getExplorerMessagingLimitCounterMessage(t, locale, {
    weekResetsUtc,
    used,
    limit,
  });

  return (
    <Alert
      variant={canSendMessage ? variant : "warning"}
      className={`border-0 shadow-sm rounded-3 mb-0 ${className}`.trim()}
    >
      <div className="small fw-medium">{message}</div>
    </Alert>
  );
}
